module.exports = __webpack_public_path__ + "4c6f80a7fec584326fd66f82396c0a9c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-23.png
// module id = 2289
// module chunks = 0